/* Opportunity / Project / Account / Calendar Activities Gantt View */
/* Group activities by parent with parent bars (oppr/proj/acct); flat activities only for cal */
/*https://blog.logrocket.com/gantt-chart-javascript-frappe-gantt/*/
<template lang="pug">
	div(class="kt-task-gantt")
		kt-spinner(v-if="d_ktt.d_loading" p_txt="Activities")
		div(v-else-if="d_ktt.d_errMessage" class="error")
			p(class="text-danger") Something went wrong ☹
			p(class="my-1 text-grey5") {{d_ktt.d_errMessage}}
			p() Please try again or refresh your browser session.
		div(v-else-if="!p_data || !p_data.length" class="nodata")
			| No {{d_ktt.c_rec_Activity.slice(0, -1) + "ies"}} found
			| {{d_ktt.d_dataParams.search ? ' matching the searched value' : ''}}
		div(v-else-if="!c_ganttTasks.length" class="nodata")
			| No dated activities
		template(v-else)
			div(class="gantt-view-toolbar")
				span View Mode:
				button(type="button" class="btn btn-sm btn-light" :class="{active: d_viewMode=='Month'}" @click="m_setViewMode('Month')") Month
				button(type="button" class="btn btn-sm btn-light" :class="{active: d_viewMode=='Year'}" @click="m_setViewMode('Year')") Year
			div(class="gantt-chart-wrap" ref="ganttWrap")
</template>

<script>
import Gantt from 'frappe-gantt';
import 'frappe-gantt/dist/frappe-gantt.css';
import {refData} from "@/utils/ref-data.js";
import {fn_hrefVwRec} from "@/utils/util.js";

const PARENT_CFG = {
	oppr: {
		idKey: 'opportunityId',
		nameKey: 'opportunityName',
		noKey: 'opportunityNo',
		statusKey: 'opportunityStatusName',
		refListKey: 'opportunityId',
		label: 'Opportunity',
		idPrefix: 'opp-',
		startField: 'createdUTC',
		endField: 'dueDate',
		customClass: 'status-opportunity',
		navKey: 'oppr',
	},
	proj: {
		idKey: 'projectId',
		nameKey: 'projectName',
		noKey: 'projectNo',
		statusKey: 'projectStatusName',
		refListKey: 'projectId',
		label: 'Project',
		idPrefix: 'proj-',
		startField: 'constructionStartDate',
		endField: 'constructionCompletionDate',
		customClass: 'status-project',
		navKey: 'proj',
	},
	acct: {
		idKey: 'accountId',
		nameKey: 'accountName',
		noKey: 'accountNo',
		statusKey: null,
		refListKey: 'accountId',
		label: 'Account',
		idPrefix: 'acct-',
		// No parent date fields — duration from longest activity span (min start → max end)
		startField: null,
		endField: null,
		customClass: 'status-account',
		navKey: 'acct',
	},
};

export default {
	name: "kt-task-gantt",
	data() {
		return {
			d_ktt: this.$parent,
			d_viewMode: 'Month',
			gantt: null,
		};
	},
	props: {
		p_data: {type: Array, default: () => []},
		p_refData: {type: Object, default: () => ({})},
		p_idKey: {type: String, default: 'opportunityTaskId'},
		p_prntRecKey: {type: String, default: 'oppr'},
	},
	computed: {
		c_parentCfg() {
			return PARENT_CFG[this.p_prntRecKey] || PARENT_CFG.oppr;
		},
		c_ganttTasks() {
			// Calendar Activities: flat list of activity bars only (no parent grouping)
			
			  const curYr = new Date().getFullYear();
              const yearStart = `${curYr}-01-01`;
              const yearEnd   = `${curYr}-12-31`;
			  const chartStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
			  const chartEndDate = new Date(chartStartDate.getFullYear() + 1, chartStartDate.getMonth(), chartStartDate.getDate());
			  let start;
			  let end;

		 
			if (this.p_prntRecKey === 'cal') {
				const tasks = [];
				(this.p_data || []).forEach((row, ix) => {
	
	          // Normalize incoming dates
             start = fn_isoDate(row.startDate);
             end   = fn_isoDate(row.endDate);

             // ❗ REQUIRE BOTH startDate and endDate
             if (!start || !end) return;

            // Skip tasks completely outside the year
             if (new Date(end) < chartStartDate || new Date(start) > chartEndDate) return;	
				
					const mapped = fn_mapActivityTask(row, ix, this.p_idKey, this.p_refData, true);
					if (mapped) tasks.push(mapped);
				});
				
				return tasks;
			}
			

			const cfg = this.c_parentCfg;
			const groups = fn_groupByParent(this.p_data || [], cfg.idKey);
			const tasks = [];

			groups.forEach(group => {
				const activityTasks = [];
				group.rows.forEach(({row, ix}) => {
				
                if(!row.startDate||!row.endDate) return;
				if (new Date(row.endDate) < chartStartDate || new Date(row.startDate) > chartEndDate) return;
				
				console.log(`Adding ${row.startDate} to ${row.endDate}`);
				 const mapped = fn_mapActivityTask(row, ix, this.p_idKey, this.p_refData);
					if (mapped) activityTasks.push(mapped);
				});

				const parent = fn_lookupParent(group.parentId, this.p_refData, cfg.refListKey, cfg.idKey);
				const firstRow = group.rows[0] && group.rows[0].row;
				const parentName = (parent && (parent[cfg.nameKey] || parent[cfg.noKey]))
					|| (firstRow && (firstRow[cfg.nameKey] || firstRow[cfg.noKey]))
					|| (cfg.label + ' ' + (group.parentId || ''));
				const parentNo = (parent && parent[cfg.noKey])
					|| (firstRow && firstRow[cfg.noKey])
					|| null;

				let parentStart = fn_isoDate(parent && parent[cfg.startField]);
				let parentEnd = fn_isoDate(parent && parent[cfg.endField]);

				if ((!parentStart || !parentEnd) && activityTasks.length) {
					const starts = activityTasks.map(t => t.start).sort();
					const ends = activityTasks.map(t => t.end).sort();
					if (!parentStart) parentStart = starts[0];
					if (!parentEnd) parentEnd = ends[ends.length - 1];
				}

				if (!parentStart && !parentEnd && !activityTasks.length) return;
				if (!parentStart && parentEnd) parentStart = parentEnd;
				if (parentStart && !parentEnd) parentEnd = parentStart;
				if (!parentStart || !parentEnd) return;

				if (parentEnd < parentStart) {
					const tmp = parentStart;
					parentStart = parentEnd;
					parentEnd = tmp;
				}

				tasks.push({
					id: cfg.idPrefix + (group.parentId != null ? group.parentId : 'none'),
					name: parentName,
					start: parentStart,
					end: parentEnd,
					progress: 100, // full bar fill — solid parent color
					custom_class: cfg.customClass,
					_isParent: true,
					_parentNo: parentNo,
					_parentNavKey: cfg.navKey,
					_parentLabel: cfg.label,
					_status: (parent && parent[cfg.statusKey]) || '',
					_lead: '',
				});

				activityTasks.forEach(t => tasks.push(t));
			});

			return tasks;
		},		
	},
	mounted() {
	    console.log('this.p_data',this.p_data);
		console.log('this.p_refData',this.p_refData);
		console.log('this.p_prntRecKey',this.p_prntRecKey);
		this.m_renderGantt();
	},
	beforeDestroy() {
		this.m_clearGantt();
	},
	methods: {
		m_setViewMode(mode) {
			this.d_viewMode = mode;
			if (this.gantt) {
				this.gantt.change_view_mode(mode);
				this.m_afterGanttRender();
			}
		},
		m_clearGantt() {
			this.gantt = null;
			const wrap = this.$refs.ganttWrap;
			if (wrap) wrap.innerHTML = '';
		},
       m_renderGantt() {
         this.$nextTick(() => {
            const wrap = this.$refs.ganttWrap;
            const tasks = this.c_ganttTasks;


        if (!wrap || !Array.isArray(tasks) || tasks.length === 0) {
            this.gantt = null;
            return;
        }

        wrap.innerHTML = '';
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        wrap.appendChild(svg);

        const vc = this;
		
		console.log('tasks:', tasks);

        this.gantt = new Gantt(svg, tasks, {
		    columns:[],
            view_mode: this.d_viewMode,
            view_modes: ['Month', 'Year'],
            popup_trigger: 'mouseover',
            custom_popup_html: (task) => fn_popupHtml(task),
            on_click: (task) => vc.m_barClick(task),
        });

        fn_patchGanttYearStart(this.gantt);
        this.gantt.change_view_mode(this.d_viewMode);
        this.m_afterGanttRender();
      });
    },
		m_afterGanttRender() {
			// Wait for frappe-gantt label BBox positioning, then bind clicks + avatar badges
			this.$nextTick(() => {
				requestAnimationFrame(() => {
					requestAnimationFrame(() => {
						this.m_bindBarClicks();
						this.m_injectAvatars();
					});
				});
			});
		},
		m_bindBarClicks() {
			const wrap = this.$refs.ganttWrap;
			if (!wrap || !this.gantt) return;
			const vc = this;
			wrap.querySelectorAll('.bar-wrapper').forEach(el => {
				if (el._ktGanttClickBound) return;
				el._ktGanttClickBound = true;
				el.addEventListener('click', () => {
					if (!vc.gantt) return;
					const task = vc.gantt.get_task(el.getAttribute('data-id'));
					vc.m_barClick(task);
				});
			});
		},
		m_injectAvatars() {
			const wrap = this.$refs.ganttWrap;
			if (!wrap || !this.gantt) return;
			wrap.querySelectorAll('.gantt-avatars').forEach(el => el.remove());
			(this.gantt.tasks || []).forEach(task => {
				if (task._isParent || !(task._people && task._people.length)) return;
				const wrapper = wrap.querySelector('.bar-wrapper[data-id="' + CSS.escape(String(task.id)) + '"]');
				if (!wrapper) return;
				fn_drawAvatarGroup(wrapper, task._people);
			});
		},
		m_barClick(task) {
			if (!task) return;
			if (task._isParent) {
				if (!task._parentNo || !task._parentNavKey) return;
				this.$router.push({path: fn_hrefVwRec(task._parentNavKey, task._parentNo)});
				return;
			}
			if (!task._row) return;
			this.$emit('edit', {row: task._row, ix: task._ix});
		},
	},
	watch: {
		p_data: {
			handler() {
				this.m_renderGantt();
			},
			deep: true,
		},
		p_refData: {
			handler() {
				this.m_renderGantt();
			},
			deep: true,
		},
		p_prntRecKey() {
			this.m_renderGantt();
		},
	},
};

function fn_groupByParent(rows, idKey) {
	const groups = [];
	const byId = {};
	rows.forEach((row, ix) => {
		const key = row[idKey] != null ? String(row[idKey]) : '__none__';
		if (!byId[key]) {
			byId[key] = {parentId: row[idKey] != null ? row[idKey] : null, rows: []};
			groups.push(byId[key]);
		}
		byId[key].rows.push({row, ix});
	});
	return groups;
}

/** Timeline starts at Jan 1 of the current year and only extends forward. */
function fn_patchGanttYearStart(gantt) {
	if (!gantt || gantt._ktYearStartPatched) return;
	gantt._ktYearStartPatched = true;

	gantt.setup_gantt_dates = function() {
		let end = null;
		for (const task of this.tasks) {
			if (!end || task._end > end) end = task._end;
		}

		const yearStart = new Date(new Date().getFullYear(), 0, 1);
		const chartStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
		const chartEndDate = new Date(chartStartDate.getFullYear() + 1, chartStartDate.getMonth(), chartStartDate.getDate());
		//this.gantt_start = yearStart;
		//this.gantt_end = end ? new Date(end.getTime()) : new Date(yearStart.getTime());
		this.gantt_start = chartStartDate;
        this.gantt_end = chartEndDate;
		
		// Forward padding only (no past padding)
		if (this.options.view_mode === 'Month') {
			//this.gantt_end = new Date(this.gantt_end);
			//this.gantt_end.setFullYear(this.gantt_end.getFullYear() + 1);
			//this.gantt_end = new Date(new Date().getFullYear(), 12, 31);
			this.gantt_end = chartEndDate;
		} else if (this.options.view_mode === 'Year') {
			this.gantt_end = new Date(this.gantt_end);
			this.gantt_end.setFullYear(this.gantt_end.getFullYear() + 2);
		} else {
			this.gantt_end = new Date(this.gantt_end);
			this.gantt_end.setMonth(this.gantt_end.getMonth() + 1);
		}

		if (this.gantt_end <= this.gantt_start) {
			this.gantt_end = new Date(yearStart.getFullYear() + 1, 0, 1);
		}
	};

	// frappe-gantt offsets the Month-view year label by a fixed 6 columns (assumes a full Jan–Dec year);
	// center it over the months of that year actually drawn, since the chart starts mid-year
	const baseGetDateInfo = gantt.get_date_info;
	gantt.get_date_info = function(date, last_date, i) {
		const info = baseGetDateInfo.call(this, date, last_date, i);
		if (this.options.view_mode === 'Month' && info.upper_text) {
			const year = date.getFullYear();
			let months = 0;
			for (let j = i; j < this.dates.length && this.dates[j].getFullYear() === year; j++) months++;
			info.upper_x = (i + months / 2) * this.options.column_width;
		}
		return info;
	};

	// Keep the bottom scrollbar at the year start instead of jumping to the first task
	gantt.set_scroll_position = function() {
		const parent_element = this.$svg && this.$svg.parentElement;
		if (!parent_element) return;
		parent_element.scrollLeft = 0;
	};
}

function fn_lookupParent(parentId, refDataObj, refListKey, idKey) {
	if (parentId == null) return null;
	const list = (refDataObj && refDataObj[refListKey]) || [];
	return list.find(o => o[idKey] == parentId) || null;
}

function fn_mapActivityTask(row, ix, idKey, refDataObj, flat) {

    const chartStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
	const chartEndDate = new Date(chartStartDate.getFullYear() + 1, chartStartDate.getMonth(), chartStartDate.getDate());
    
	let start = fn_isoDate(row.startDate) || fn_isoDate(row.dueDate);
    if (!start) return null;

    let end = fn_isoDate(row.endDate) || fn_isoDate(row.dueDate) || start;

    if (end < start) {
        const tmp = start;
        start = end;
        end = tmp;
    }

    // Normalize — this prevents the .length crash
    start = fn_isoDate(start);
    end = fn_isoDate(end);
    if (!start || !end) return null;
	
	
	//start = Math.max(start,chartStartDate);
    //end = Math.min(end,chartEndDate);

	
    const status = fn_statusName(row);
    const lead = fn_leadName(row, refDataObj);
    const progress = Number(row.percentComplete) || 0;
    const taskName = row.taskName || 'Untitled';
    const people = fn_activityPeople(row, refDataObj, lead);

    return {
        id: String(row[idKey] != null ? row[idKey] : ix),
        name: flat ? taskName : ('↳ ' + taskName),
        start,
        end,
        progress,
        custom_class: fn_statusClass(status),
        _row: row,
        _ix: ix,
        _status: status,
        _lead: lead,
        _people: people,
        _isParent: false,
    };
}

function fn_isoDate(val) {
	if (!val) return null;
	if (val instanceof Date) {
		if (isNaN(val.getTime())) return null;
		return val.toISOString().slice(0, 10);
	}
	const m = String(val).match(/^(\d{4}-\d{2}-\d{2})/);
	return m ? m[1] : null;
}

function fn_statusName(row) {
	if (row.taskStatusName) return row.taskStatusName;
	return (refData.taskStatus(row.taskStatusId, null) || {}).name || '';
}

function fn_statusClass(status) {
	const slug = String(status || 'unknown').toLowerCase().replace(/\s+/g, '-');
	return 'status-' + slug;
}

function fn_leadName(row, refDataObj) {
	if (row.taskLeadName) return row.taskLeadName;
	const tms = (refDataObj && refDataObj.teamMemberId) || [];
	const tm = tms.find(t => t.teamMemberId == row.taskLeadId);
	return (tm && tm.teamMemberName) || '';
}

function fn_initials(name) {
	if (!name) return null;
	const parts = String(name).trim().split(/\s+/).filter(Boolean);
	if (!parts.length) return null;
	return parts.map(w => w[0]).join('').slice(0, 2).toUpperCase();
}

function fn_teamMemberNameById(teamMemberId, refDataObj) {
	if (teamMemberId == null) return '';
	const tms = (refDataObj && refDataObj.teamMemberId) || [];
	const tm = tms.find(t => t.teamMemberId == teamMemberId);
	return (tm && tm.teamMemberName) || '';
}

const AVATAR_COLORS = ['#4fa4ff', '#41b8d5', '#9b59b6', '#f5a623', '#27ae60', '#e74c3c', '#1e8449', '#7f77dd'];

function fn_avatarColor(teamMemberId, ix) {
	if (teamMemberId != null && !isNaN(Number(teamMemberId))) {
		return AVATAR_COLORS[Math.abs(Number(teamMemberId)) % AVATAR_COLORS.length];
	}
	return AVATAR_COLORS[ix % AVATAR_COLORS.length];
}

/** Lead first, then assignees; de-dupe by teamMemberId. */
function fn_activityPeople(row, refDataObj, leadName) {
	const seenIds = {};
	const people = [];

	const pushPerson = (id, name) => {
		const key = id != null ? 'id:' + id : 'nm:' + name;
		if (seenIds[key]) return;
		const init = fn_initials(name);
		if (!init) return;
		seenIds[key] = true;
		people.push({
			teamMemberId: id,
			name: name || '',
			initials: init,
			color: fn_avatarColor(id, people.length),
		});
	};

	if (row.taskLeadId != null || leadName) {
		pushPerson(row.taskLeadId, leadName || fn_teamMemberNameById(row.taskLeadId, refDataObj));
	}

	(row.taskAssignees || []).forEach(a => {
		const name = a.teamMemberName || fn_teamMemberNameById(a.teamMemberId, refDataObj);
		pushPerson(a.teamMemberId, name);
	});

	return people;
}

const SVG_NS = 'http://www.w3.org/2000/svg';

function fn_svgEl(tag, attrs) {
	const el = document.createElementNS(SVG_NS, tag);
	Object.keys(attrs || {}).forEach(k => {
		if (k === 'textContent') el.textContent = attrs[k];
		else el.setAttribute(k, attrs[k]);
	});
	return el;
}

/** Draw color-coded initial circles next to the activity bar label. */
function fn_drawAvatarGroup(wrapper, people) {
	const label = wrapper.querySelector('.bar-label');
	const bar = wrapper.querySelector('.bar');
	if (!bar) return;

	const r = 8;
	const step = r * 2 - 3;
	let startX;
	let cy;

	if (label) {
		try {
			const bb = label.getBBox();
			startX = bb.x + bb.width + 8;
			cy = bb.y + bb.height / 2;
		} catch (e) {
			startX = (+bar.getAttribute('x') || 0) + (+bar.getAttribute('width') || 0) + 8;
			cy = (+bar.getAttribute('y') || 0) + (+bar.getAttribute('height') || 0) / 2;
		}
	} else {
		startX = (+bar.getAttribute('x') || 0) + (+bar.getAttribute('width') || 0) + 8;
		cy = (+bar.getAttribute('y') || 0) + (+bar.getAttribute('height') || 0) / 2;
	}

	const g = fn_svgEl('g', {class: 'gantt-avatars', 'pointer-events': 'none'});
	people.forEach((p, i) => {
		const cx = startX + i * step + r;
		g.appendChild(fn_svgEl('circle', {
			cx: cx,
			cy: cy,
			r: r,
			fill: p.color,
			stroke: '#fff',
			'stroke-width': 1.5,
			class: 'gantt-avatar-circle',
		}));
		const t = fn_svgEl('text', {
			x: cx,
			y: cy,
			class: 'gantt-avatar-text',
			'text-anchor': 'middle',
			'dominant-baseline': 'central',
			fill: '#fff',
			'font-size': '8',
			'font-weight': '700',
			textContent: p.initials,
		});
		if (p.name) t.setAttribute('title', p.name);
		g.appendChild(t);
	});
	wrapper.appendChild(g);
}

function fn_esc(str) {
	return String(str == null ? '' : str)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

function fn_popupHtml(task) {
	if (task._isParent) {
		return `<div class="title">${fn_esc(task.name)}</div>
			<div class="subtitle">${fn_esc(task.start)} - ${fn_esc(task.end)}</div>
			<div>${fn_esc(task._parentLabel || 'Parent')}</div>
			${task._status ? `<div>Status: ${fn_esc(task._status)}</div>` : ''}`;
	}
	const progress = task.progress != null ? task.progress + '%' : ' ';
	const lead = task._lead ? fn_esc(task._lead) : '—';
	const status = task._status ? fn_esc(task._status) : '—';
	return `<div class="title">${fn_esc(task.name)}</div>
		<div class="subtitle">${fn_esc(task.start)} - ${fn_esc(task.end)}</div>
		<div>Status: ${status}</div>
		<div>Lead: ${lead}</div>
		<div>Progress: ${fn_esc(progress)}</div>`;
}
</script>

<style lang="less">
.kt-task-gantt {
	.gantt-view-toolbar {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		margin: 0.4em 0 0.6em;
		span {
			margin-right: 0.4em;
		}
		.btn {
			margin-right: 0.25em;
			&.active {
				background-color: #dee2e6;
			}
		}
	}
	.gantt-chart-wrap {
		overflow-x: auto;
		min-height: 12em;
	}
	.nodata,
	.error {
		width: 100%;
		font-size: 1em;
		text-align: center;
		padding: 0.5em 0;
	}

	.status-opportunity .bar,
	.status-opportunity .bar-progress { fill: #28a745; }
	.status-opportunity {
		cursor: pointer;
	}
	.status-project .bar,
	.status-project .bar-progress { fill: #0074f0; }
	.status-project {
		cursor: pointer;
	}
	.status-account .bar,
	.status-account .bar-progress { fill: #fd7e14; }
	.status-account {
		cursor: pointer;
	}
	.status-to-do .bar { fill: #c5ccd3; }
	.status-to-do .bar-progress { fill: #adb5bd; }
	.status-in-progress .bar { fill: #8fc4fd; }
	.status-in-progress .bar-progress { fill: #2d8bba; }
	.status-completed .bar { fill: #8fd19e; }
	.status-completed .bar-progress { fill: #28a745; }
	.status-on-hold .bar { fill: #f0c36d; }
	.status-on-hold .bar-progress { fill: #e0a800; }
	.status-canceled .bar { fill: #f5b7b1; }
	.status-canceled .bar-progress { fill: #dc3545; }

	.gantt-avatar-text {
		fill: #fff;
		font-size: 8px;
		font-weight: 700;
		pointer-events: none;
		user-select: none;
	}
}
</style>
